export const extractOceanTaskData = (listData) => {
      const byPO = Object.create(null);
      const byContainer = Object.create(null);

      for (const t of listData) {
        if (!t || (typeof t === "object" && !Array.isArray(t) && Object.keys(t).length === 0)) {
          continue;
        }
        const po = getCustomField(t, "3a271beb-3557-47d8-98b5-e29ff80b6fff");
        const container = getCustomField(t, "eb15a15b-fae4-4a5c-9b15-d84460eed943");

        const mini = {
          arrivalNotice: getCustomField(t, "b210c2af-d3fd-4cf3-b8a5-ad0572e2a8ec"),
          BOL: getCustomField(t, "a9cfc6a4-63b8-4d6e-9317-30f449b3f59c"),
          bookedDate: getCustomField(t, "4b57a371-411e-4965-8861-570559c3131f"),
          commercialInvoice: getCustomField(t, "6905ec71-7eba-42bb-84e8-d393d2941d9c"),
          containerNumber: getCustomField(t, "eb15a15b-fae4-4a5c-9b15-d84460eed943"),
          customer: getCustomField(t, "fd3a86a7-c6d8-4fa5-9b7f-5a88292df461"),
          customerRefNumber: getCustomField(t, "f94e04d1-7827-478b-9f9b-ff5d7e61105b"),
          customsCleared: getCustomField(t, "913f8600-68d6-4450-987b-0d5c211f7d1e"),
          DO: getCustomField(t, "f723b87a-9b3b-4f5e-a16f-0f94535801e4"),
          equipmentOrder: getCustomField(t, "d09ecbde-a1fb-4618-b414-a26dd86a5ffe"),
          estimatedDateOfArrival: getCustomField(t, "817cea26-7508-4f3a-8a65-851868018ba0"),
          ISF: getCustomField(t, "39c41c06-a9e5-41d1-98e0-8f1468de1b5a"),
          poNumber: getCustomField(t, "3a271beb-3557-47d8-98b5-e29ff80b6fff"),
          sailingDocument: getCustomField(t, "bbd2daef-a7dd-43c9-907a-ce5146a6b45b"),
          POD: getCustomField(t, "7536864d-dbad-4b16-823a-53382a61dd54"),
          packingList: getCustomField(t, "3ff7c86a-9241-4f8b-b75e-c455dc3cb205"),
          salesOrder: getCustomField(t, "ff8c3d56-2eca-494d-bdad-4a64e1ac8234"),
          description: t.description,
        }
        
        if (po) (byPO[po] ??= []).push(mini);
        if (container) (byContainer[container] ??= []).push(mini);
      }
      return { byPO, byContainer }
}

function getCustomField(task, fieldId) {
  const f = task.custom_fields.find(cf => cf.id === fieldId);
  return f ? f.value: null;
}

export const parseClickupTableDescription = (text, columns) => {
    const lines = text.trim().split(/\r?\n/);
    const headers = lines.slice(0,columns).map(h => h.toUpperCase());
    const values = lines.slice(columns)

    const result = [];
    for (let i=0; i < values.length; i += headers.length) {
      const obj = {};
      headers.forEach((h, idx) => {
        obj[h] = values[i + idx] ?? null;
      });
      result.push(obj)
    }
    return result
  }